import React, { FC } from 'react'
import { decodeId, getMenuItemsFromNodes } from './util'
import {
    StyledNavigationMenuContainer,
    StyledNavigationMenuItemContainer,
} from './ContentNav.styled'
import { ContentNavMenuItem } from './ContentNavMenuItem'
import { HomeMenuItem } from './components/HomeMenuItem'
import { HamburgerMenuItem } from './components/HamburgerMenuItem'
import { ProviderChildProps } from '../FlyoutNav/FlyoutNav'

export interface ContentNavProps {
    isMobile: boolean
    flyOutProps?: ProviderChildProps
    handleScrollNavigation: () => void
    offset: number
    nodes: Element[]
    activeSection?: string
}

export const ContentNav: FC<ContentNavProps> = ({
    isMobile,
    flyOutProps,
    handleScrollNavigation,
    offset,
    activeSection,
    nodes,
}) => {
    const menuItems = getMenuItemsFromNodes(nodes)

    return menuItems.length > 0 && activeSection ? (
        <StyledNavigationMenuContainer className="contentNavMenu">
            {!isMobile && <HamburgerMenuItem flyOutProps={flyOutProps} />}
            <StyledNavigationMenuItemContainer>
                {isMobile && <HomeMenuItem />}
                {menuItems.map((menuItem) => (
                    <ContentNavMenuItem
                        section={menuItem.section}
                        heading={menuItem.heading}
                        offset={offset}
                        isSelected={
                            activeSection === decodeId(menuItem.heading)
                        }
                        handleScrollNavigation={handleScrollNavigation}
                        key={menuItem.heading}
                    />
                ))}
            </StyledNavigationMenuItemContainer>
        </StyledNavigationMenuContainer>
    ) : null
}
